var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.125C21.9203 27.125 27.125 21.9203 27.125 15.5C27.125 9.07969 21.9203 3.875 15.5 3.875C9.07969 3.875 3.875 9.07969 3.875 15.5C3.875 21.9203 9.07969 27.125 15.5 27.125Z",
    stroke: "#3CDB84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1406 14.5312C11.9432 14.5312 12.5938 13.8807 12.5938 13.0781C12.5938 12.2756 11.9432 11.625 11.1406 11.625C10.3381 11.625 9.6875 12.2756 9.6875 13.0781C9.6875 13.8807 10.3381 14.5312 11.1406 14.5312Z",
    fill: "#3CDB84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8594 14.5312C20.6619 14.5312 21.3125 13.8807 21.3125 13.0781C21.3125 12.2756 20.6619 11.625 19.8594 11.625C19.0568 11.625 18.4062 12.2756 18.4062 13.0781C18.4062 13.8807 19.0568 14.5312 19.8594 14.5312Z",
    fill: "#3CDB84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5374 18.4062C20.0253 19.2885 19.2904 20.0208 18.4064 20.5299C17.5223 21.0389 16.52 21.3069 15.4999 21.3069C14.4798 21.3069 13.4775 21.0389 12.5934 20.5299C11.7094 20.0208 10.9745 19.2885 10.4624 18.4062",
    stroke: "#3CDB84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile-icon.6176fce7247425798c67f81c5973aba2.svg";
export { ForwardRef as ReactComponent };